import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    actions: {
        padding: theme.spacing(1, 2),

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1, 0.5),
        },
    },
    content: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        minWidth: 300,
    },
    input: {
        height: '1.4em',
    },
    formControl: {
        margin: theme.spacing(0.5, 0),
        flexBasis: '100%',
    },
    paper: {
        width: '98%',
        maxWidth: 680,
    },
    textarea: {
        '& .MuiInput-root': {
            height: 'auto',
        },
    },
    title: {
        padding: theme.spacing(2, 2, 1),

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2, 1, 1),
        },
    },
}));

export { useStyles };
